import { render } from "./AppGalleryDesc.vue?vue&type=template&id=f60b9b90"
import script from "./AppGalleryDesc.vue?vue&type=script&lang=js"
export * from "./AppGalleryDesc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__